import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { uploadFileAction } from "../actions/category";
import { RoutesPaths } from "../Router/constant";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { bannerAddAction } from "../actions/banner";
import { allCategories } from "../actions/category";
import { allStores } from "../actions/store";
import Select from "react-select";

export default function AddBanner() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [selectedCategoryId, setSelectedCategoryId] = useState("");
  const [selectedStoreId, setSelectedStoreId] = useState("");
  const [selectedTypeId, setSelectedTypeId] = useState("");

  /* =======================
     STATES
  ======================= */
  const [formData, setFormData] = useState({
    name: {
      en: "",
      pt: "",
    },
    description: {
      en: "",
      pt: "",
    },
    link: "",
  });
  const [imagePreview, setImagePreview] = useState(null);
  const [isimageId, setImageId] = useState();
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const getBannerType = () => {
    switch (selectedTypeId) {
      case "0":
        return "main";
      case "1":
        return "category";
      case "2":
        return "store";
      case "3":
        return "external";
      case "4":
        return "service";
      default:
        return "main";
    }
  };

  const [categoryList, setCategories] = useState([]);
  const [storeList, setStores] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const res = await dispatch(allCategories());

      if (res?.status === 200) {
        setCategories(res.data);
      }

      const storeRes = await dispatch(allStores());
      if (storeRes?.status === 200) {
        setStores(storeRes.data);
      }

    };

    fetchData();
  }, [dispatch]);

  /* =======================
     HANDLERS
  ======================= */
  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name.includes(".")) {
      const [field, lang] = name.split(".");

      setFormData((prev) => {
        const updatedField = {
          ...prev[field],
          [lang]: value,
        };

        const updatedData = {
          ...prev,
          [field]: updatedField,
        };

        // ✅ FIX: Only remove error if BOTH fields are filled
        if (field === "name") {
          if (
            updatedField.en.trim() !== "" &&
            updatedField.pt.trim() !== ""
          ) {
            setErrors((prevErr) => ({
              ...prevErr,
              name: "",
            }));
          }
        }

        if (field === "description") {
          if (
            updatedField.en.trim() !== "" &&
            updatedField.pt.trim() !== ""
          ) {
            setErrors((prevErr) => ({
              ...prevErr,
              description: "",
            }));
          }
        }

        return updatedData;
      });
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));

      if (name === "link") {
        setErrors((prev) => ({
          ...prev,
          link: "",
        }));
      }
    }
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // ✅ File validation
    if (!["image/png", "image/jpeg", "image/jpg"].includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        icon: "Only PNG, JPG, JPEG files are allowed",
      }));
      return;
    }
    setErrors((prev) => ({ ...prev, icon: "" }));
    setImagePreview(URL.createObjectURL(file));
    const payload = new FormData();
    payload.append("files", file);
    try {
      const response = await dispatch(uploadFileAction(payload));
      if (response?.data) {
        setImageId(response.data.data._id);
      }
    } catch (error) {
      setErrors((prev) => ({
        ...prev,
        icon: "Image upload failed",
      }));
    }
  };

  const handleRemoveImage = () => {
    setImagePreview(null);
  };

  /* =======================
     VALIDATION
  ======================= */
  const validate = () => {
    let newErrors = {};
    console.log(selectedTypeId, 'selectedTypeId', selectedCategoryId, 'oopopop')
    if (!formData.name.en.trim() || !formData.name.pt.trim()) {
      newErrors.name = "Both English and Portuguese names are required";
    }
    if (!selectedTypeId) {
      newErrors.type = "Banner type is required";
    }

    if (!imagePreview) {
      newErrors.icon = "Banner image is required";
    }

    if (selectedTypeId === "1" && !selectedCategoryId) {
      newErrors.category = "Category is required";
    }

    if (selectedTypeId === "2" && !selectedStoreId) {
      newErrors.store = "Store is required";
    }

    if (selectedTypeId === "3" && !formData.link) {
      newErrors.link = "External link is required";
    }

    if (selectedTypeId === "4" && !formData.link) {
      newErrors.link = "External link is required";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  /* =======================
     SUBMIT
  ======================= */
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validate()) return;

    setLoading(true);

    try {
      const type = getBannerType();

      let payload = {
        name: formData.name,
        description: formData.description,
        type,
        image: isimageId,
      };

      // ✅ Add dynamic fields
      if (type === "category") {
        payload.categoryId = selectedCategoryId;
      }

      if (type === "store") {
        payload.storeId = selectedStoreId;
      }

      if (type === "external") {
        payload.link = formData.link;
      }

      const resp = await dispatch(bannerAddAction(payload));

      if (resp?.data?.success) {
        navigate(RoutesPaths.BANNER);
      }
    } catch (error) {
      toast.error("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const canceChanges = () => {
    navigate(RoutesPaths.BANNER);
  };

  const handleTypeChange = (e) => {
    setSelectedTypeId(e.target.value);

    setErrors((prev) => ({
      ...prev,
      type: "",
    }));
  };

  const handleCategoryChange = (e) => {
    setSelectedCategoryId(e.target.value);

    setErrors((prev) => ({
      ...prev,
      category: "",
    }));
  };
  const handleStoreChange = (e) => {
    setSelectedStoreId(e.target.value);

    setErrors((prev) => ({
      ...prev,
      store: "",
    }));
  };
  /* =======================
     JSX
  ======================= */
  return (
    <div className="container-fluid mainConatinerSection">
      <form
        className="form d-flex flex-column flex-lg-row"
        onSubmit={handleSubmit}
      >
        {/* LEFT SIDE */}
        <div className="d-flex flex-column gap-7 gap-lg-10 w-100 w-lg-300px mb-7 me-lg-10">
          {/* IMAGE UPLOAD */}
          <div className="card card-flush py-4">
            <div className="card-header">
              <div className="card-title">
                <h2 className="required">Thumbnail</h2>
              </div>
            </div>

            <div className="card-body text-center pt-0">
              <div
                className={`image-input image-input-outline mb-3 ${imagePreview
                  ? ""
                  : "image-input-empty image-input-placeholder"
                  }`}
              >
                <div
                  className="image-input-wrapper w-150px h-150px"
                  style={{
                    backgroundImage: imagePreview
                      ? `url(${imagePreview})`
                      : "none",
                  }}
                ></div>

                <label className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow pencilIconSection">
                  <i className="ki-duotone ki-pencil fs-7">
                    <span className="path1 searchPath"></span>
                    <span className="path2 searchPath"></span>
                  </i>
                  <input
                    type="file"
                    accept=".png,.jpg,.jpeg"
                    hidden
                    onChange={handleImageChange}
                  />
                </label>

                {imagePreview && (
                  <span
                    className="btn btn-icon btn-circle btn-active-color-primary w-25px h-25px bg-body shadow closeIconSection"
                    onClick={handleRemoveImage}
                  >
                    <i className="ki-duotone ki-cross fs-2">
                      <span className="path1"></span>
                      <span className="path2"></span>
                    </i>
                  </span>
                )}
              </div>

              {errors.icon && (
                <div className="text-danger fs-7">{errors.icon}</div>
              )}

              <div className="text-muted fs-7">
                Only *.png, *.jpg and *.jpeg image files are accepted
              </div>
            </div>
          </div>

          {/* STATUS */}
          {/* <div className="card card-flush py-4">
                <div className="card-header">
                  <div className="card-title">
                    <h2>Status</h2>
                  </div>
                </div>

                <div className="card-body pt-0">
                  <select
                    className="form-select"
                    name="status"
                    value={formData.status}
                    onChange={handleChange}
                  >
                    <option value="published">Published</option>
                    <option value="scheduled">Scheduled</option>
                    <option value="unpublished">Unpublished</option>
                  </select>
                </div>
              </div> */}
        </div>

        {/* RIGHT SIDE */}
        <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
          <div className="card card-flush py-4">
            <div className="card-header">
              <div className="card-title">
                <h2>General</h2>
              </div>
            </div>

            <div className="card-body pt-0">
              <div className="mb-10">
                <label className="required form-label">Banner Name (English)</label>
                <input
                  type="text"
                  name="name.en"
                  className="form-control mb-2"
                  placeholder="Banner name in English"
                  value={formData.name.en}
                  onChange={handleChange}
                />

                <label className="required form-label mt-3">Banner Name (Portuguese)</label>
                <input
                  type="text"
                  name="name.pt"
                  className="form-control mb-2"
                  placeholder="Banner name in Portuguese"
                  value={formData.name.pt}
                  onChange={handleChange}
                />

                {errors.name && (
                  <div className="text-danger fs-7">{errors.name}</div>
                )}
              </div>

              <div className="mb-10">
                <label className="form-label">Description (English)</label>
                <textarea
                  name="description.en"
                  className="form-control mb-2"
                  placeholder="Description in English"
                  value={formData.description.en}
                  onChange={handleChange}
                />

                <label className="form-label mt-3">Description (Portuguese)</label>
                <textarea
                  name="description.pt"
                  className="form-control mb-2"
                  placeholder="Description in Portuguese"
                  value={formData.description.pt}
                  onChange={handleChange}
                />
              </div>

              <div className="mb-10 fv-row">
                <label className="required form-label">Select type</label>

                <Select
                  placeholder="Select a type"
                  value={[
                    { value: "0", label: "Main" },
                    { value: "1", label: "Category" },
                    { value: "2", label: "Store" },
                    { value: "3", label: "External" },
                  ].find(opt => opt.value === selectedTypeId)}

                  options={[
                    { value: "0", label: "Main" },
                    { value: "1", label: "Category" },
                    { value: "2", label: "Store" },
                    { value: "3", label: "External" },
                  ]}

                  onChange={(selected) =>
                    handleTypeChange({ target: { value: selected.value } })
                  }
                />
                {errors.type && (
                  <div className="text-danger fs-7">{errors.type}</div>
                )}
              </div>

              {selectedTypeId == "1" && (
                <div className="mb-10 fv-row">
                  <label className="required form-label">Select category</label>

                  <Select
                    placeholder="Select a category"
                    value={categoryList?.data
                      ?.map(item => ({ value: item._id, label: item.name }))
                      .find(opt => opt.value === selectedCategoryId)
                    }
                    options={categoryList?.data?.map(item => ({
                      value: item._id,
                      label: item.name
                    }))}
                    onChange={(selected) => handleCategoryChange({ target: { value: selected.value } })}
                  />

                  {errors.category && (
                    <div className="text-danger fs-7">{errors.category}</div>
                  )}
                </div>

              )}

              {selectedTypeId == "2" && (
                <div className="mb-10 fv-row">
                  <label className="required form-label">Select store</label>

                  <Select
                    placeholder="Select a store"
                    value={storeList?.data
                      ?.map(item => ({ value: item._id, label: item.shopName }))
                      .find(opt => opt.value === selectedStoreId)
                    }

                    options={storeList?.data?.map(item => ({
                      value: item._id,
                      label: item.shopName
                    }))}

                    onChange={(selected) =>
                      handleStoreChange({ target: { value: selected.value } })
                    }
                  />
                  {errors.store && (
                    <div className="text-danger fs-7">{errors.store}</div>
                  )}
                </div>
              )}

              {selectedTypeId == "3" && (
                <div>
                  <label className="required form-label">External link</label>
                  <input
                    type="text"
                    name="link"
                    className="form-control mb-2"
                    placeholder="Add link"
                    value={formData.link}
                    onChange={handleChange}
                  />
                  {errors.link && (
                    <div className="text-danger fs-7">{errors.link}</div>
                  )}
                </div>

              )}
              {selectedTypeId == "4" && (
                <div>
                  <label className="required form-label">External link</label>
                  <input
                    type="text"
                    name="link"
                    className="form-control mb-2"
                    placeholder="Add link"
                    value={formData.link}
                    onChange={handleChange}
                  />
                  {errors.link && (
                    <div className="text-danger fs-7">{errors.link}</div>
                  )}
                </div>

              )}
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button className="btn btn-light me-5" onClick={canceChanges}>
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="btn buttonPrimary"
            >
              {!loading && <>Save Changes</>}
              {loading && (
                <div className="indicator-label">
                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                  Please wait...
                </div>
              )}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
}
